import Tooltip from '@material-ui/core/Tooltip'
import cn from 'classnames'
import React from 'react'
import styled from 'styled-components'

const LinkWrapper = styled.a`
  display: inline-block;
  line-height: 1;
  cursor: pointer;
  padding: 6px 0 7px;
`

const Label = styled.label`
  display: block;
  font-weight: 300;
  margin: 0;
  &:hover {
    cursor: default;
  }
`

const Link = ({ className, children, label, title, ...rest }) => (
  <React.Fragment>
    {label ? <Label>{label}</Label> : null}
    <Tooltip title={title} placement="right">
      <LinkWrapper className={cn(className, 'custom-link')} {...rest}>
        {children}
      </LinkWrapper>
    </Tooltip>
  </React.Fragment>
)

Link.defaultProps = {
  className: '',
  title: '',
}

export default Link
